<template>
  <div class="main">
    <div class="boardmain" @click="bilunew">
      <div class="new"><span>新</span></div>
      <img
        src="../images/bilunewicon.png"
        style="width:100px;height:100px;"
        class="imgshowinit imgtype"
      />
      <img src="../images/bilunewiconCh.png" style="width:100px;height:100px;" class="imgshow imgtype" />
      <div>卫监笔录系统</div>
      <div class="intoline">
        <span class="intotext">进入</span>
        <img src="../images/inplatinit.png" style="width:30px;height:30px;" class="imgshowinit" />
        <img src="../images/inplatform.png" style="width:30px;height:30px;" class="imgshow" />
      </div>
    </div>
    <!-- <div class="boardmain" @click="xinxi">
      <img
        src="../images/infoinit.png"
        style="width:100px;height:100px;"
        class="imgshowinit imgtype"
      />
      <img src="../images/info.png" style="width:100px;height:100px;" class="imgshow imgtype" />
      <div>信息管理系统</div>
      <div class="intoline">
        <span class="intotext">进入</span>
        <img src="../images/inplatinit.png" style="width:30px;height:30px;" class="imgshowinit" />
        <img src="../images/inplatform.png" style="width:30px;height:30px;" class="imgshow" />
      </div>
    </div>
    <div class="boardmain" @click="bilu">
      <img
        src="../images/systeminit.png"
        style="width:100px;height:100px;"
        class="imgshowinit imgtype"
      />
      <img src="../images/system.png" style="width:100px;height:100px;" class="imgshow imgtype" />
      <div>卫监笔录系统</div>
      <div class="intoline">
        <span class="intotext">进入</span>
        <img src="../images/inplatinit.png" style="width:30px;height:30px;" class="imgshowinit" />
        <img src="../images/inplatform.png" style="width:30px;height:30px;" class="imgshow" />
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  date() {
    return {};
  },
  methods: {
    // bilu() {
    //   window.location.href="http://www.ggws.com.cn/manage/login"
    // },
    // xinxi() {
    //   window.location.href = "http://www.ggws.com.cn/gswjapp";
    //   // http://www.ggws.com.cn/gswjApp/parameter/getMD5Key.do?_=1677137105687
    // },
    bilunew(){
      window.location.href = "/login";
    }
  }
};
</script>
<style scoped>
.intoline {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}

.intotext {
  font-size: 32px;
  color: #999;
  font-weight: bold;
  margin-right: 20px;
}

.main {
  background: url("https://zjiva.terabits.cn/var/file/biluback.png") no-repeat
    bottom center;
  background-size: cover;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-evenly;
  height: 98vh;
  padding: 0 8%;
}
.boardmain {
  position: relative;
  width: 308px;
  height: 416px;
  border: 1px solid #cacaca;
  background: #f5f5f5;
  border-radius: 20px;
  text-align: center;
  cursor: pointer;
  font-size: 42px;
  font-weight: bold;
  color: #333333;
}
.new{
  position: absolute;
  top: 0;
  right: 0;
  line-height: 130px;
  width: 150px;
  height: 150px;
  border-radius:0 20px 0 0 ;
  background-color: #0c88de;
  background: linear-gradient(45deg,transparent 50%,#e6f3fc ,#e6f3fc 50%, #e6f3fc 100%);
  color: #0c88de;
  font-size: 32px;
  font-weight: normal;
}
.new span{
  position: absolute;
    top: -10%;
    right: 10%;
}
.boardmain:hover .new {
  background: linear-gradient(45deg,transparent 50%,#0c88de ,#0c88de 50%, #0c88de 100%);

  color: #fff;
}

.imgtype {
  margin-top: 87px;
  margin-bottom: 60px;
}

.imgshow {
  display: none;
}

.imgshowinit {
  display: inline-block;
}

.boardmain:hover {
  border: 1px solid #0c88de;
  background: #e6f3fc;
}

.boardmain:hover .imgshow {
  display: inline-block;
}

.boardmain:hover .intotext {
  color: #0c88de;
}

.boardmain:hover .imgshowinit {
  display: none;
}
</style>